var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStateOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3144_535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.96736 0.301613C6.36702 -0.123115 7.86457 -0.0987296 9.24965 0.371345C10.6347 0.841419 11.8378 1.73357 12.6898 2.92247C13.5418 4.11138 14 5.53732 14 7H12.1739C12.1739 5.91889 11.8353 4.86493 11.2055 3.98618C10.5758 3.10742 9.68655 2.44801 8.66279 2.10056C7.63903 1.75311 6.53215 1.73509 5.49762 2.04902C4.46309 2.36295 3.55289 2.99306 2.89486 3.85085L1.44598 2.73938C2.33626 1.57885 3.56771 0.726342 4.96736 0.301613Z",
    fill: "var(--secondary-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.214815 8.72083C-0.0794262 7.56065 -0.071265 6.3444 0.238519 5.18827L2.00238 5.66089C1.77341 6.51542 1.76738 7.41439 1.98486 8.27192C2.20235 9.12945 2.63608 9.91689 3.24463 10.559L1.9192 11.8151C1.09587 10.9464 0.509057 9.88102 0.214815 8.72083Z",
    fill: "var(--secondary-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66415 13.5988C6.25976 14.1636 8.00599 14.1311 9.57951 13.5074C11.153 12.8837 12.4472 11.7109 13.2225 10.2063L11.5993 9.36985C11.0262 10.482 10.0696 11.3488 8.9066 11.8098C7.74356 12.2708 6.45287 12.2948 5.2735 11.8773L4.66415 13.5988Z",
    fill: "var(--secondary-6)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3144_535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStateOutlined);
export default __webpack_public_path__ + "static/media/stateOutlined.19c2b4ff93bb09cb66b63d9a41664a8f.svg";
export { ForwardRef as ReactComponent };